import Socket from '../connection/socket';
import * as SessionActions from '../stores/actions/session';
import * as InvitationsActions from '../stores/actions/invitations';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { GreenroomState } from '../stores/types/types';
import { LimitedInputConfig } from '../stores/types/session';
import { selectPlatformRedirectUrl } from '../stores/selectors/session';

export default function Users(socket: Socket) {
	function handleLimitedInputConfigUpdate(message: { message: LimitedInputConfig }) {
		const {
			SessionReducer: {
				limitedInput,
			},
		} = getState() as GreenroomState;

		if (limitedInput && message.message) {
			const {
				view,
				smartCanvas,
				locationId,
			} = message.message;

			const configQuery = new URLSearchParams({
				'limited-input': '1',
				view: view.toString(),
				...(view === 'canvas' && { smartCanvas: smartCanvas.toString() }),
				...(view === 'canvas' && locationId && { locationId: locationId.toString() }),
			});
			window.location.href = `${window.location.pathname}?${configQuery.toString()}`;
		}
	}

	socket.addListener('user-updated', (message: any) => {
		if (!message) return;
		socketListenerDispatch(SessionActions.userUpdated(message));
		socketListenerDispatch(InvitationsActions.inviteProfileEdited(message));
	});
	socket.addListener('users-connected', (message: any) => {
		socketListenerDispatch(SessionActions.usersList(message, socket.resetConnectedUsers));
		if (socket.resetConnectedUsers) socket.resetConnectedUsers = false;
	});
	socket.addListener('user-connected', (message: any) => {
		socketListenerDispatch(SessionActions.userConnected(message));
	});
	socket.addListener('user-disconnected', (message: any) => socketListenerDispatch(SessionActions.userDisconnected(message)));
	socket.addListener('duplicate-user-kicked', () => {
		console.log('kicked off => ');
		if (getState()?.SessionReducer?.limitedInput) {
			window.location.href = `${process.env.REACT_APP_LOGIN_URL}/conference-auth`;
		} else if (window.location.pathname.startsWith('/producer')) {
			window.location.href = selectPlatformRedirectUrl(getState() as GreenroomState) ?? '/producer';
		} else {
			window.location.href = '/';
		}
	});
	socket.addListener('duplicate-user-take-over', () => {
		// this is fired for the user who clicked to take over as the main
		// user feed, and should reload the page to take over the feed
		if (getState()?.SessionReducer?.limitedInput) {
			window.location.href = window.location.href + '?limited-input=1';
		} else {
			window.location.reload();
		}
	});
	socket.addListener('limited-input-config-update', handleLimitedInputConfigUpdate);
}
